import { CustomTab, CustomTabs, TabPanel } from "components/common/CustomTabs/CustomTabs";
import React, { useState } from "react";
import { Column } from "components/common/Layout/Column";
import { ActiveTravelOffersList } from "./ActiveTravelOffersList";
import { ActiveRidesList } from "./ActiveRidesList";

export const TravelsTab = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Column sx={{ width: "100%" }}>
      <CustomTabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
        <CustomTab label="Solicitudes de viaje" />
        <CustomTab label="Viajes activos" />
      </CustomTabs>

      <TabPanel value={value} index={0}>
        <ActiveTravelOffersList />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <ActiveRidesList />
      </TabPanel>
    </Column>
  );
};
